import React from 'react'
import Button from 'components/shared/Button'
import Moment from 'react-moment'
import Chip from '@material-ui/core/Chip'
import CheckIcon from '@material-ui/icons/Check'

const AllStatesPreviousSearchCard = (props) => {
    const { previousSearch, viewResult, search, searchLoading, applicantId, onViewDetails } = props

    const handleViewResults = () => {
        if (onViewDetails) {
            onViewDetails(previousSearch)
        } else if (previousSearch.results && previousSearch.results.length > 0) {
            viewResult(previousSearch.results[0])
        }
    }

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'completed':
            case 'success':
                return 'primary'
            case 'pending':
            case 'in_progress':
                return 'default'
            case 'error':
            case 'failed':
                return 'secondary'
            default:
                return 'default'
        }
    }

    const getStatusStyle = (status) => {
        switch (status?.toLowerCase()) {
            case 'completed':
            case 'success':
                return { backgroundColor: '#e8f5e8', color: '#2e7d2e' }
            default:
                return {}
        }
    }

    return (
        <div className='uccRow bg-white rounded' style={{ border: '1px solid #ddd', margin: '5px 0' }}>
            <div className='row align-items-center p-2'>
                <div className='col-md-3'>
                    <span>{previousSearch.businessName || 'N/A'}</span>
                </div>
                <div className='col-md-2'>
                    <span>{previousSearch.createdAt ? <Moment format="MM/DD/YYYY">{previousSearch.createdAt}</Moment> : 'N/A'}</span>
                </div>
                <div className='col-md-2'>
                    <Chip
                        label={previousSearch.status || 'Completed'}
                        color={previousSearch.status?.toLowerCase() === 'completed' || previousSearch.status?.toLowerCase() === 'success' ? 'default' : getStatusColor(previousSearch.status)}
                        size="small"
                        style={getStatusStyle(previousSearch.status)}
                    />
                </div>
                <div className='col-md-2'>
                    {previousSearch.bestMatch && (
                        <CheckIcon style={{ color: 'var(--status-approved)' }} fontSize="small" />
                    )}
                </div>
                <div className='col-md-3'>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={handleViewResults}
                    >
                        View Details
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default AllStatesPreviousSearchCard